module.exports = {
	"Play": "پخش",
	"Pause": "وقفه",
	"Current Time": "زمان کنونی",
	"Duration Time": "مدت زمان",
	"Remaining Time": "زمان باقیمانده",
	"Stream Type": "نوع استریم",
	"LIVE": "زنده",
	"Loaded": "فراخوانی شده",
	"Progress": "پیشرفت",
	"Fullscreen": "تمام صفحه",
	"Non-Fullscreen": "نمایش عادی",
	"Mute": "بی صدا",
	"Unmute": "بهمراه صدا",
	"Playback Rate": "سرعت پخش",
	"Subtitles": "زیرنویس",
	"subtitles off": "بدون زیرنویس",
	"Captions": "عنوان",
	"captions off": "بدون عنوان",
	"Chapters": "فصل",
	"You aborted the media playback": "شما پخش را متوقف کردید.",
	"A network error caused the media download to fail part-way.": "مشکل در دریافت ویدئو ...",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "فرمت پشتیبانی نمیشود یا خطایی روی داده است.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "مشکل در دریافت ویدئو ...",
	"No compatible source was found for this media.": "هیچ ورودی ای برای این رسانه شناسایی نشد."
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-video-player/lang/fa.json
// module id = 249
// module chunks = 86